/* eslint-disable react/jsx-indent */
import React, { Component } from 'react';
import {
  Grid,
  Dropdown,
  Divider,
  Button,
  List,
  Form,
  TextArea,
  Checkbox,
  Modal,
  Segment,
  Label,
  Message,
  Icon,
  Popup
} from 'semantic-ui-react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import _ from 'lodash';
import { toast, ToastContainer } from 'react-toastify';
import { getProductSets } from '../../fbApi/ProductCatalog';
import { getAudiences, getDetailedTargeting } from '../../fbApi/Audience';
import {
  getPageWithPageToken,
  getPageBackedInstagramAccounts
} from '../../fbApi/Page';
import { getAccount } from '../../fbApi/Account';
import { buildCampaign } from './CampaignBuilder';
import {
  returnUpdatedLaunchingStatus,
  launchAdsetsForCampaign,
  getInitRelaunchStatuses,
  returnRelaunchData,
  relaunchFailedAdsInPackage,
  createTestForm,
  getProductSetOptions,
  getLaunchingStatusMessage,
  getIconForLaunchingStatus,
  returnFailedCollectionAdStatuses
} from './PackageLaunchActions';
import './PackageLaunch.css';
import constants from './constants/constants';
import * as Launcher from './PackageLauncher';
import PackageLaunchAdSectionComponent from './PackageLaunchAdSectionComponent';
import PackageLaunchLookalikeMaker from './PackageLaunchLookalikeMaker';
import CollectionToCinempraphSelectionModal from '../../components/common/Launcher/CollectionToCinempraphSelectionModal';
import { optimizationGoalsValues } from '../../components/common/OptimizationGoals';

const {
  ACTIVE,
  ADDRESS,
  PRODUCT_CATALOG_SALES,
  CONVERSIONS,
  LINK_CLICKS,
  COLLECTION,
  VIDEO_VIEWS,
  CAROUSEL,
  CLIENT_NAME,
  ZIP,
  INCLUDE,
  EXCLUDE,
  DETAILED_INCLUDE,
  DETAILED_EXCLUDE
} = constants.LAUNCHER;

class PackageLaunch extends Component {
  state = {
    message: '',
    token: this.props.getFbToken(),
    processing: false,
    audienceOptions: this.props.audienceOptions || [],
    includeTargetingOptions: [],
    excludeTargetingOptions: [],
    includeTargetingSelected: [], // detailed targeting ids
    excludeTargetingSelected: [], // detailed targeting ids
    searchingTargeting: '', // empty string indicates that detailed targeting is not being loaded. Otherwise, Dropdown name will be assigned.
    targetingSearchTimeoutId: -1,
    utmProfilesOptions: [],
    form: {
      status: ACTIVE,
      accountId: '',
      accountName: '',
      pageId: '',
      campaigns: [],
      adsets: [],
      ads: [],
      pixel: '',
      startDate: '',
      endDate: '',
      displayUrl: '',
      address: '',
      radius: '',
      description: '',
      pageAccessToken: '',
      utmOverrideSelected: null,
      spendCaps: [
        /**
         * {
         *  campaignId,
         *  spendCap
         * }
         */
      ],
      instagramAccount: '',
      packageWideProductCatalog: null
    },
    accountIdText: '',
    pageIdText: '',
    productCatalogs: [],
    productSets: [], // { ad.id : []}
    adProductSets: [],
    fillTestData: false,
    collectionExists: false,
    locationType: ADDRESS, // Address or Zip
    // Thoese below zip fields will have data only if locationType === 'Zip'
    zipCodesToInclude: '',
    zipCodesToExclude: '',
    checkedAdIds: [],
    launchingStatus: null,
    // [
    //     {
    //       id: -1,
    //       name: '',
    //       status: '', // Pending, Launching, Succeed, Failed
    //       adsets: [
    //         {
    //           id: -1,
    //           name: '',
    //           status: '',
    //           ads: [
    //             {
    //               id: -1,
    //               name: '',
    //               status: ''
    //             }
    //           ]
    //         }
    //       ]
    //     }
    // ]
    error: {
      type: null, // ACCOUNT_NOT_SELECTED
      title: '',
      message: ''
    },
    duplicateAdCounters: [],
    relaunchData: [],
    packageContainsHecCampaign: false,
    adsNeedQcApproval: false,
    includeLookalikes: true,
    launchingPackage: false,
    buildingAudiences: false,
    retargetingAudiences: null,
    lookalikeAudiences: null,
    isFailedCollectionAdModalOpen: false,
    idsOfCollectionAdsToConvert: [],
    collectionAdsToRelaunch: [],
    firstDestUrlAppliedToDisplayUrl: false,
    showInfoToast: false,
    infoToastText: '',
    adseDuplicationStopped: false
  };

  componentDidMount() {
    this.verifyAdsQcAndInitializeForm();
    this.initializeLaunchParameters();
    this.countDuplicateAds(this.props.packageToLaunch.ads);
    if (!this.props.pages || !this.props.pages.length) {
      this.props.fetchPages();
    }
  }

  packageLaunchAdSectionComponentRef = (ref) => {
    this.packageLaunchAdSectionComponent = ref;
  };

  verifyAdsQcAndInitializeForm = () => {
    const { packageToLaunch } = this.props;
    const { ads } = packageToLaunch;
    let adsNeedQcApproval = false;
    let index = 0;
    while (!adsNeedQcApproval && index < ads.length) {
      const { ad: innerAd } = ads[index] || {};
      {
        const { qc_approved: qcApproved } = innerAd || {};
        if (!qcApproved || !innerAd) {
          adsNeedQcApproval = true;
        } else {
          index = index + 1;
        }
      }
    }

    if (adsNeedQcApproval) {
      toast.warn(
        `Some ads in this package have not been QC'ed. The package cannot be launched unless all ads have been approved`,
        {
          position: 'top-center',
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        }
      );
    }

    this.setState(
      (prevState) => ({ ...prevState, adsNeedQcApproval }),
      () => {
        this.initializeLaunchingStatus();
      }
    );
  };

  // Initialize the form to launch package
  initializeLaunchingStatus = () => {
    const {
      includeLookalikes,
      launchingPackage,
      retargetingAudiences,
      lookalikeAudiences
    } = this.state;
    const { packageToLaunch, utmProfiles } = this.props;
    const { campaigns, adsets, ads, package: packageObj } = packageToLaunch;
    const {
      start_date: startDate = '',
      end_date: endDate = '',
      product_description: description = ''
    } = packageObj;

    const form = {
      ...this.state.form
    };

    if (!form.startDate) {
      form.startDate = startDate ? new Date(startDate) : '';
    }

    if (!form.endDate) {
      form.endDate = endDate ? new Date(endDate) : '';
    }

    if (!form.description) {
      form.description = description;
    }

    const utmProfilesOptions = utmProfiles.map((utm, index) => ({
      key: index,
      text: utm.name,
      value: utm.id
    }));

    const campaignStatusList = campaigns.map((campaign) => {
      const {
        id: campaignId,
        name: campaignName,
        tags,
        is_hec_campaign: isHecCampaign
      } = campaign;

      const newCampaign = {};
      newCampaign.id = campaignId;
      newCampaign.tags = tags;
      newCampaign.isHecCampaign = isHecCampaign;
      form.campaigns.push(newCampaign);

      let adsetStatusList = adsets
        .filter((adset) => adset.campaignId === campaignId)
        .map((adset) => {
          const { id: adSetId, adSetName, selectedAudiences } = adset;
          if (selectedAudiences && selectedAudiences.length > 0) {
            const newAdset = {
              id: adSetId,
              campaignId,
              audiences: selectedAudiences
            };
            form.adsets.push(newAdset);
          }

          const adStatusList = ads
            .filter((ad) => ad.adSetId === adSetId)
            .map((ad) => {
              const { id: adId, name: adName } = ad;
              return {
                id: adId,
                name: adName,
                status: 'Pending',
                errorMessage: null
              };
            });

          return {
            id: adSetId,
            status: 'Pending',
            name: adSetName,
            errorMessage: null,
            ads: adStatusList
          };
        });

      if (includeLookalikes && launchingPackage) {
        let badNamingConvention = false;
        const nonDaaAdsetStatuses = adsetStatusList.filter((adsetStatus) =>
          adsets.find((adset) => adset.id === adsetStatus.id && !adset.daaType)
        );
        nonDaaAdsetStatuses.forEach((adsetStatus) => {
          const { name, id, ads: statusAds } = adsetStatus;
          const retargetNameSplit = name.split('_');
          const lookalikeNameSplit = name.split('_');

          if (!retargetNameSplit[4] || !lookalikeNameSplit[4]) {
            badNamingConvention = true;
            return;
          }

          retargetNameSplit[4] = 'Retargeting';
          lookalikeNameSplit[4] = 'Lookalike';

          const retargetAdsetName = retargetNameSplit.join('_');
          const lookalikeAdsetName = lookalikeNameSplit.join('_');

          const adsetStatusObjs = [
            {
              ...adsetStatus,
              id: id * 2,
              name: retargetAdsetName,
              ads: statusAds.map((ad) => {
                const adNameSplit = ad.name.split('_');
                const splitLength = adNameSplit.length;
                const retargetAdName = `${retargetAdsetName}_${adNameSplit
                  .slice(splitLength - 2, splitLength)
                  .join('_')}`;
                return { ...ad, id: ad.id * 2, name: retargetAdName };
              })
            },
            {
              ...adsetStatus,
              id: id * 2 + 1,
              name: lookalikeAdsetName,
              ads: statusAds.map((ad) => {
                const adNameSplit = ad.name.split('_');
                const splitLength = adNameSplit.length;
                const lookalikeAdName = `${lookalikeAdsetName}_${adNameSplit
                  .slice(splitLength - 2, splitLength)
                  .join('_')}`;
                return { ...ad, id: ad.id * 2 + 1, name: lookalikeAdName };
              })
            }
          ];
          adsetStatusList = adsetStatusList.concat(adsetStatusObjs);
          const foundFormAdset = form.adsets.find(
            (adset) => adset.id === adsetStatus.id
          );
          const newFormAdsets = [
            {
              ...(foundFormAdset || {}),
              id: id * 2,
              name: retargetAdsetName,
              campaignId,
              audiences: [
                (
                  retargetingAudiences.find(
                    (audienceObj) => audienceObj.campaignId === campaignId
                  ) || {}
                ).retargetingAudience
              ]
            },
            {
              ...(foundFormAdset || {}),
              id: id * 2 + 1,
              campaignId,
              name: lookalikeAdsetName,
              audiences: [
                (
                  lookalikeAudiences.find(
                    (audienceObj) => audienceObj.campaignId === campaignId
                  ) || {}
                ).lookalikeAudience
              ]
            }
          ];
          form.adsets = form.adsets.concat(newFormAdsets);
          const formAdsInAdset = form.ads.filter((ad) => ad.adSetId === id);
          const duplicateFormAds = formAdsInAdset
            ? formAdsInAdset
                .map((ad) => {
                  const retargetAdId = ad.id * 2;
                  const retargetAdsetId = ad.adSetId * 2;

                  const lookalikeAdId = ad.id * 2 + 1;
                  const lookalikeAdsetId = ad.adSetId * 2 + 1;

                  return [
                    {
                      ...ad,
                      duplicateType: 'retargeting',
                      id: retargetAdId,
                      adSetId: retargetAdsetId
                    },
                    {
                      ...ad,
                      duplicateType: 'lookalike',
                      id: lookalikeAdId,
                      adSetId: lookalikeAdsetId
                    }
                  ];
                })
                .flat()
            : [];
          form.ads = form.ads.concat(duplicateFormAds);
        });
        if (!badNamingConvention) {
          toast.info(
            `Retargeting and Lookalike adsets have been added to the Launch queue for ${campaignName}`,
            {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true
            }
          );
          this.setState({ ...this.state, form, adseDuplicationStopped: false });
        } else {
          toast.warn(
            `Some adsets have bad naming convetions${campaignName}. Adding Lookalike and Retargeting adsets was stopped.`,
            {
              position: 'top-right',
              autoClose: 6000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true
            }
          );
          this.setState({ ...this.state, adseDuplicationStopped: true });
        }
      }

      return {
        id: campaignId,
        name: campaignName,
        status: 'Pending',
        errorMessage: null,
        adsets: adsetStatusList
      };
    });

    this.setState((prevState) => ({
      ...prevState,
      form,
      launchingStatus: campaignStatusList,
      utmProfilesOptions
    }));
  };

  updateLaunchingStatus = (
    type,
    id,
    status,
    errorMessage = null,
    facebookObjectId
  ) => {
    const { launchingStatus, checkedAdIds } = this.state; // launchingStatus is list of campaigns

    const campaigns = returnUpdatedLaunchingStatus(
      launchingStatus,
      type,
      id,
      status,
      errorMessage,
      facebookObjectId,
      checkedAdIds
    );

    this.setState((prevState) => ({
      ...prevState,
      launchingStatus: campaigns
    }));
  };

  initializeLaunchParameters = () => {
    const { packageToLaunch } = this.props;
    const { ads, adsets } = packageToLaunch || {};
    const { form } = this.state;
    let checkedAdIds = [];
    let includeLookalikes = true;

    const packageContainsHecCampaign = form.campaigns.findIndex(
      (campaignStatus) => campaignStatus.isHecCampaign
    );

    if (ads) {
      checkedAdIds = ads.map((ad) => ad.id);
    }

    if (adsets) {
      includeLookalikes =
        adsets.filter((adset) => adset.daaType).length !== adsets.length;
    }

    if (packageContainsHecCampaign) {
      form.radius = '20';
    }

    this.setState((prevState) => ({
      ...prevState,
      form,
      checkedAdIds,
      includeLookalikes,
      packageContainsHecCampaign: packageContainsHecCampaign !== -1
    }));
  };

  onAccountSelect = async (event, { value, options }) => {
    if (value) {
      const account = _.find(options, (option) => {
        return option.value === value;
      });
      const accountId = account.value;
      const accountName = account.text;
      const accountData = await getAccount(accountId, this.state.token);
      const form = { ...this.state.form, accountId, accountName };

      if (
        accountData &&
        accountData.adspixels &&
        accountData.adspixels.data[0]
      ) {
        form.pixel = accountData.adspixels.data[0].id;
      } else {
        form.pixel = '';
      }

      const audiencesResult = await getAudiences(accountId, this.state.token);
      const audiences = audiencesResult[0].data.concat(audiencesResult[1].data);

      const audienceOptions = _.sortBy(
        _.map(audiences, (op, index) => ({
          key: index,
          value: op.id,
          text: op.name
        })),
        'text'
      );

      this.setState({
        ...this.state,
        form,
        audienceOptions,
        accountIdText: accountId
      });
    } else {
      const form = {
        ...this.state.form,
        accountId: '',
        accountName: '',
        pixel: ''
      };
      this.setState({
        ...this.state,
        form,
        audienceOptions: [],
        accountIdText: ''
      });
    }
  };

  handleAccountIdTextChange = (event, { value }) => {
    this.setState(
      {
        ...this.state,
        accountIdText: value
      },
      async () => {
        const foundAccount = this.props.accounts.find(
          (account) => account.value === value
        );
        if (foundAccount) {
          await this.onAccountSelect(undefined, {
            value,
            options: this.props.accounts
          });
        }
      }
    );
  };

  onSelectPage = async (event, { value, options }) => {
    if (value) {
      const form = this.state.form;

      const selectedPage = _.find(options, (opt) => {
        return opt.value === value;
      });

      if (selectedPage) {
        const { pageId, access_token: accessToken } = selectedPage.value;
        const pageResult = await getPageWithPageToken(pageId, accessToken);

        if (
          pageResult &&
          pageResult.instagram_accounts &&
          pageResult.instagram_accounts.data
        ) {
          form.instagramAccount = pageResult.instagram_accounts.data[0].id;
        } else {
          const instagramResult = await getPageBackedInstagramAccounts(
            pageId,
            accessToken
          );
          if (
            instagramResult &&
            instagramResult.data &&
            instagramResult.data[0]
          ) {
            form.instagramAccount = instagramResult.data[0].id;
          }
        }

        form.pageId = pageId;
        form.pageAccessToken = accessToken;

        this.setState({
          form,
          pageIdText: pageId
        });
      }
      // TODO: show error message for page not found
    } else {
      const form = {
        ...this.state.form,
        pageId: '',
        pageAccessToken: '',
        instagramAccount: ''
      };
      this.setState({
        ...this.state,
        form,
        pageIdText: ''
      });
    }
  };

  handlePageIdChange = (event, { value }) => {
    this.setState(
      {
        ...this.state,
        pageIdText: value
      },
      async () => {
        const foundPage = this.props.pages.find(
          (page) => page.value.pageId === value
        );

        if (foundPage) {
          await this.onSelectPage(undefined, {
            value: foundPage.value,
            options: this.props.pages
          });
        }
      }
    );
  };

  handleCampaignChange = (event, { name, value, id }) => {
    const form = this.state.form;
    const campaign = form.campaigns.find((item) => item.id === id);

    if (!campaign) {
      const newCampaign = {};
      newCampaign.id = id;
      newCampaign[name] = value;
      form.campaigns.push(newCampaign);
    } else {
      const index = form.campaigns.indexOf(campaign);
      campaign[name] = value;
      form.campaigns[index] = campaign;
    }

    this.setState({ form });
  };

  handleAdSetChange = (event, { name, value, id, campaignId }) => {
    const form = this.state.form;
    const adset = form.adsets.find((item) => item.id === id);

    if (!adset) {
      const newAdset = {};
      newAdset.id = id;
      newAdset[name] = value;
      newAdset.campaignId = campaignId;
      form.adsets.push(newAdset);
    } else {
      const index = form.adsets.indexOf(adset);
      adset[name] = value;
      form.adsets[index] = adset;
    }

    this.setState({ form });
  };

  setFormStateAfteFormChange = (stateForm, fieldName, value) => {
    const form = stateForm;
    // eslint-disable-next-line no-useless-escape
    const validDestinationRegex = /^http(s)?\:\/\/(www\.)?([a-zA-Z0-9]+)\.([a-zA-Z0-9]+)(\/(.+)?)?$/g;

    const willApplyUrl =
      fieldName === 'destinationUrl' &&
      validDestinationRegex.test(value) &&
      !this.state.firstDestUrlAppliedToDisplayUrl &&
      form.displayUrl.trim() === '';

    if (willApplyUrl) {
      // eslint-disable-next-line no-useless-escape
      const httpRegex = /http(s)?\:\/\/(www\.)?/g;
      const endSlashRegex = /\/(.+)?$/g;
      const cleanedUrl = value
        .replace(httpRegex, '')
        .replace(endSlashRegex, '');

      form.displayUrl = cleanedUrl;
    }

    const newState = { ...this.state, form };

    if (willApplyUrl) {
      newState.firstDestUrlAppliedToDisplayUrl = true;
      newState.showInfoToast = true;
      newState.infoToastText =
        'Destination URL trimmed and applied to Display URL';
    }

    this.setState(newState);
  };

  handleAdCardChange = (event, { value, id, adId, adSetId, cardId }) => {
    const form = this.state.form;
    const ad = form.ads.find((item) => item.id === id);

    if (!ad) {
      const newAd = {
        id,
        adId,
        adSetId,
        cards: [{ cardId, destinationUrl: value }]
      };
      form.ads.push(newAd);
    } else {
      const index = form.ads.indexOf(ad);
      let card = ad.cards.find((item) => item.cardId === cardId);
      if (!card) {
        card = { cardId, destinationUrl: value };
        ad.cards.push(card);
      } else {
        card.destinationUrl = value;
      }

      form.ads[index] = ad;
    }

    this.setFormStateAfteFormChange(form, 'destinationUrl', value);
  };

  handleAdChange = (event, { name, value, id, adId, adSetId }) => {
    const form = this.state.form;
    const ad = form.ads.find((item) => item.id === id);

    if (!ad) {
      const newAd = {
        id,
        adId,
        adSetId
      };
      newAd[name] = value;
      form.ads.push(newAd);
    } else {
      const index = form.ads.indexOf(ad);
      ad[name] = value;
      form.ads[index] = ad;
    }

    this.setFormStateAfteFormChange(form, name, value);
  };

  handleAdsBatchChange = ({ destinationUrl }) => {
    const { ads } = this.props.packageToLaunch;
    const form = { ...this.state.form };

    ads.forEach((ad) => {
      const { id, adSetId, ad: innerAd } = ad;
      const formAd = form.ads.find((item) => item.id === ad.id);
      if (!formAd) {
        const newAd = {
          id,
          adSetId,
          adId: innerAd.id,
          type: innerAd.type
        };
        this.replaceUrlForAd(newAd, destinationUrl, innerAd.cards);
        form.ads.push(newAd);
      } else {
        formAd.type = formAd.type || innerAd.type;
        const index = form.ads.indexOf(formAd);
        this.replaceUrlForAd(formAd, destinationUrl, innerAd.cards);
        form.ads[index] = formAd;
      }
    });
    toast.info('URL Applied to all URL fields.', {
      position: 'bottom-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
    this.setState({ ...this.state, form });
  };

  replaceUrlForAd = (formAd, urlValue, cards) => {
    const alteredAd = formAd;
    const { type } = alteredAd;

    switch (type) {
      case CAROUSEL:
        alteredAd.cards = cards.map((card) => ({
          cardId: card.id,
          destinationUrl: urlValue
        }));
        break;
      case COLLECTION:
        alteredAd.footerUrl = urlValue;
        break;
      default:
        alteredAd.destinationUrl = urlValue;
        break;
    }
  };

  handleLaunchButtonClick = () => {
    const {
      form,
      checkedAdIds,
      zipCodesToInclude,
      includeLookalikes,
      packageContainsHecCampaign
    } = this.state;
    const { packageToLaunch } = this.props;

    const invalidFields = !Launcher.validFields(
      form,
      zipCodesToInclude,
      checkedAdIds,
      packageToLaunch,
      packageContainsHecCampaign
    );

    const invalidMessage = packageContainsHecCampaign
      ? 'You must complete the fields to launch the package, where radius must be at least 15mi.'
      : 'You must complete the fields to launch the package';

    if (invalidFields) {
      this.setState({
        message: invalidMessage
      });
      return;
    }
    if (includeLookalikes) {
      // setting this state will trigger audiences to be built
      // after which launchPackage() will be invoked
      this.setState({
        ...this.state,
        launchingPackage: true
      });
    } else {
      this.launchPackage();
    }
  };

  // Method to launch package to Facebook. It launches all the campaigns with adsets and ads depending on its types
  launchPackage = () => {
    this.initializeLaunchingStatus();
    const { packageToLaunch } = this.props;
    this.setState({ message: '', processing: true }, async () => {
      const { form, token } = this.state;
      const {
        accountName: formAccountName,
        accountId: formAccountId,
        campaigns: formCampaigns
      } = form;

      await Promise.all(
        packageToLaunch.campaigns.map(async (campaign) => {
          const {
            id: campaignId,
            objective: campaignObjective,
            name: campaignName,
            is_hec_campaign: isHecCampaign
          } = campaign;

          this.updateLaunchingStatus(
            'Campaign',
            campaignId,
            'Launching',
            '',
            null
          );

          const campaignParameters = formCampaigns.find(
            (item) => item.id === campaign.id
          );

          const {
            spendCap: spendCapParameter,
            tags: tagsParameter,
            productCatalog: productCatalogParameter
          } = campaignParameters;

          const campaignData = {
            name: campaignName.replace(CLIENT_NAME, formAccountName),
            objective: campaignObjective,
            lifetime_budget: spendCapParameter * 100,
            budget_remaining: spendCapParameter * 100,
            accountId: formAccountId,
            tags: tagsParameter,
            isHecCampaign: isHecCampaign || false
          };

          if (campaignObjective === PRODUCT_CATALOG_SALES) {
            campaignData.productCatalog = productCatalogParameter;
          }

          const resultCampaign = await buildCampaign(campaignData, token);

          let status = '';
          let errorMessage = null;

          if (resultCampaign.id) {
            status = 'Succeed';
          } else {
            status = 'Failed';
            const { error } = resultCampaign;

            const {
              error_user_title: errorUserTitle,
              error_user_msg: errorUserMsg
            } = error || {};
            errorMessage = error
              ? `${errorUserTitle} ${errorUserMsg}`
              : 'An unknown error occurred';
          }

          this.updateLaunchingStatus(
            'Campaign',
            campaignId,
            status,
            errorMessage,
            resultCampaign.id || null
          );

          await launchAdsetsForCampaign(
            this.state,
            this.props,
            campaign,
            resultCampaign.id,
            this.updateLaunchingStatus,
            this.packageLaunchAdSectionComponent
          );

          return Promise.resolve(resultCampaign);
        })
      );

      this.setState(
        (prevState) => ({
          ...prevState,
          processing: false,
          launchingPackage: false
        }),
        () => {
          this.prepareRelaunchData();
        }
      );
    });
  };

  prepareRelaunchData = () => {
    const { packageToLaunch } = this.props;
    const { launchingStatus } = this.state;
    const relaunchData = returnRelaunchData(launchingStatus, packageToLaunch);
    this.setState(
      (prevState) => ({
        ...prevState,
        relaunchData
      }),
      () => {
        const failedCollectionStatuses = returnFailedCollectionAdStatuses(
          this.state.relaunchData
        );

        if (failedCollectionStatuses.length > 0) {
          this.setState((prevState) => ({
            ...prevState,
            isFailedCollectionAdModalOpen: true,
            collectionAdsToRelaunch: failedCollectionStatuses
          }));
        }
      }
    );
  };

  handleRelaunchClick = () => {
    this.setState(
      (prevState) => ({
        ...prevState,
        relaunchInProgess: true,
        processing: true
      }),
      () => {
        const initialRelaunchStatuses = getInitRelaunchStatuses(this.state);
        this.setState(
          (prevState) => ({
            ...prevState,
            launchingStatus: initialRelaunchStatuses
          }),
          async () => {
            try {
              await relaunchFailedAdsInPackage(
                this.state,
                this.packageLaunchAdSectionComponent,
                this.updateLaunchingStatus
              );
            } catch (error) {
              console.log('Error in handleRelaunchClick():', error);
            } finally {
              this.setState(
                (prevState) => ({
                  ...prevState,
                  relaunchInProgess: false,
                  processing: false
                }),
                () => {
                  this.prepareRelaunchData();
                }
              );
            }
          }
        );
      }
    );
  };

  goBackSearch = () => {
    this.props.searchPage();
    if (window.location.href.includes('#id=')) {
      const idParamIndex = window.location.href.indexOf('#id=');
      const newUrl = window.location.href.slice(0, idParamIndex);
      window.location.replace(newUrl);
    }
  };

  onProductCatalogSelectionChange = async (event, data) => {
    const { value, name, id } = data;

    const result = await getProductSets(this.state.token, value);
    const productSets = result ? result.data : [];
    const productSetSelectionList = productSets.map((productSet, index) => ({
      key: index,
      text: productSet.name,
      value: productSet.id
    }));

    const form = this.state.form;
    const campaign = form.campaigns.find((item) => item.id === id);

    if (!campaign) {
      const newCampaign = {};
      newCampaign.id = id;
      newCampaign[name] = value;
      form.campaigns.push(newCampaign);
    } else {
      const index = form.campaigns.indexOf(campaign);
      campaign[name] = value;
      form.campaigns[index] = campaign;
    }

    this.setState({ form, productSets: productSetSelectionList });
  };

  onProductCatalogSelectionChangeAd = async (event, data) => {
    const { value, name, id } = data;

    const result = await getProductSets(this.state.token, value);
    const productSets = result ? result.data : [];
    const productSetSelectionList = productSets.map((productSet, index) => ({
      key: index,
      text: productSet.name,
      value: productSet.id
    }));

    const form = this.state.form;
    const ad = form.ads.find((item) => item.id === id);

    if (!ad) {
      const newAd = {};
      newAd.id = id;
      newAd[name] = value;
      form.ads.push(newAd);
    } else {
      const index = form.ads.indexOf(ad);
      ad[name] = value;
      form.ads[index] = ad;
    }

    this.setState((prevState) => ({
      ...prevState,
      form,
      adProductSets: {
        ...prevState.adProductSets,
        [id]: productSetSelectionList
      }
    }));
  };

  onPackagewideProductCatalogSelection = async (event, data) => {
    const { value, name } = data;

    const result = await getProductSets(this.state.token, value);
    const productSets = result ? result.data : [];
    const productSetSelectionList = productSets.map((productSet, index) => ({
      key: index,
      text: productSet.name,
      value: productSet.id
    }));

    const form = this.state.form;
    const adProductSets = { ...this.state.adProductSets };

    this.props.packageToLaunch.ads
      .filter((ad) => ad.type === COLLECTION)
      .forEach((ad) => {
        if (!ad || !ad.id) {
          return;
        }
        const formAd = form.ads.find((item) => item.id === ad.id);
        if (!formAd) {
          const newAd = {};
          newAd.id = ad.id;
          newAd[name] = value;
          form.ads.push(newAd);
        } else {
          const index = form.ads.indexOf(formAd);
          delete formAd.productSet;
          formAd[name] = value;
          form.ads[index] = formAd;
        }
        adProductSets[ad.id] = productSetSelectionList;
      });

    this.props.packageToLaunch.campaigns.forEach((campaign) => {
      const { id } = campaign;
      const formCampaign = form.campaigns.find((item) => item.id === id);
      if (!formCampaign) {
        const newCampaign = {};
        newCampaign.id = id;
        newCampaign[name] = value;
        form.campaigns.push(newCampaign);
      } else {
        const index = form.campaigns.indexOf(formCampaign);
        formCampaign[name] = value;
        form.campaigns[index] = formCampaign;
      }
    });

    this.setState((prevState) => ({
      ...prevState,
      form: {
        ...form,
        packageWideProductCatalog: value
      },
      showInfoToast: true,
      infoToastText:
        'The selected Product Catalog has been applied to all collection ads in the package.',
      adProductSets,
      productSets: productSetSelectionList
    }));
  };

  onAudienceSelectAdset = async (event, data) => {
    const audienceAdset = data.id;
    const audiences = [];

    data.value.forEach((val) => {
      const audience = _.find(data.options, (option) => {
        return option.value === val;
      });

      if (audience) {
        audiences.push(audience);
      }
    });

    const form = { ...this.state.form };
    const adset = form.adsets.find((item) => item.id === audienceAdset);

    if (!adset) {
      const newAdset = {};
      newAdset.id = audienceAdset;
      newAdset[data.name] = audiences;
      newAdset.campaignId = data.campaignId;
      form.adsets.push(newAdset);
    } else {
      const index = form.adsets.indexOf(adset);
      adset[data.name] = audiences;
      form.adsets[index] = adset;
    }

    this.setState({ form });
  };

  onProductSetSelectionChange = async (event, data) => {
    const { value, name, id, campaignid } = data;

    const form = { ...this.state.form };
    const adset = form.adsets.find((item) => item.id === id);

    if (!adset) {
      const newAdset = {};
      newAdset.id = id;
      newAdset[name] = value;
      newAdset.campaignId = campaignid;
      form.adsets.push(newAdset);
    } else {
      const index = form.adsets.indexOf(adset);
      adset[name] = value;
      form.adsets[index] = adset;
    }

    this.setState({ form });
  };

  onProductSetSelectionChangeAd = async (event, data) => {
    const { value, name, id } = data;
    const form = this.state.form;
    const ad = form.ads.find((item) => item.id === id);

    if (!ad) {
      const newAd = {};
      newAd.id = id;
      newAd[name] = value;
      form.ads.push(newAd);
    } else {
      const index = form.ads.indexOf(ad);
      ad[name] = value;
      form.ads[index] = ad;
    }

    this.setState({ form });
  };

  onLocationTypeChange = (event, { checked }) => {
    const locationType = !checked ? ADDRESS : ZIP;

    this.setState((prevState) => ({
      ...prevState,
      locationType
    }));
  };

  onZipcodeChange = (event, { value, type }) => {
    // if user paste zip codes from excel and paste it into input field, the string is separated by an empty space. If it is textarea, the string is separated by \n.

    this.setState((prevState) => ({
      ...prevState,
      zipCodesToInclude:
        type.toLowerCase() === INCLUDE ? value : prevState.zipCodesToInclude,
      zipCodesToExclude:
        type.toLowerCase() === EXCLUDE ? value : prevState.zipCodesToExclude
    }));
  };

  onDetailedTargetSelect = (event, { value, name, id: adSetId, options }) => {
    const selectedList = value
      .map((id) => {
        const option = options.find((opt) => opt.key === id);

        if (!option) return null;

        return {
          id,
          name: option.text
        };
      })
      .filter((item) => item);

    let newSelected;
    if (name === DETAILED_INCLUDE) {
      const { includeTargetingSelected } = this.state;

      if (
        includeTargetingSelected.find(
          (selection) => selection.adSetId === adSetId
        )
      ) {
        // found
        newSelected = includeTargetingSelected.map((selection) => {
          const { adSetId: prevAdsetId } = selection || {};

          const combined = [...selection.selected, ...selectedList];
          const filtered = [...new Set(combined.map((tmp) => tmp.id))].map(
            (id) => {
              const selected = combined.find((tmp) => tmp.id === id);
              return {
                ...selected
              };
            }
          );

          if (prevAdsetId && prevAdsetId === adSetId) {
            return {
              adSetId,
              selected: filtered
            };
          }

          return {
            ...selection
          };
        });
      } else {
        newSelected = [
          ...includeTargetingSelected,
          { adSetId, selected: selectedList }
        ];
      }
    } else {
      const { excludeTargetingSelected } = this.state;

      if (
        excludeTargetingSelected.find(
          (selection) => selection.adSetId === adSetId
        )
      ) {
        // found
        newSelected = excludeTargetingSelected.map((selection) => {
          const { adSetId: prevAdsetId } = selection || {};

          const combined = [...selection.selected, ...selectedList];
          const filtered = [...new Set(combined.map((tmp) => tmp.id))].map(
            (id) => {
              const selected = combined.find((tmp) => tmp.id === id);
              return {
                ...selected
              };
            }
          );

          if (prevAdsetId && prevAdsetId === adSetId) {
            return {
              adSetId,
              selected: filtered
            };
          }

          return {
            ...selection
          };
        });
      } else {
        newSelected = [
          ...excludeTargetingSelected,
          { adSetId, selected: selectedList }
        ];
      }
    }

    if (newSelected && newSelected[0] && newSelected[0].selected) {
      newSelected[0].selected = _.intersectionBy(
        newSelected[0].selected,
        selectedList,
        'id'
      );
    }

    this.setState((prevState) => ({
      ...prevState,
      includeTargetingSelected:
        name === DETAILED_INCLUDE
          ? newSelected.filter((item) => item)
          : prevState.includeTargetingSelected,
      excludeTargetingSelected:
        name === DETAILED_EXCLUDE
          ? newSelected.filter((item) => item)
          : prevState.excludeTargetingSelected
    }));
  };

  onDetailedTargetSearch = (event, { searchQuery: query, name }) => {
    event.preventDefault();
    const { form } = this.state;
    const { accountId } = form;

    if (!accountId) {
      this.setState((prevState) => ({
        ...prevState,
        error: {
          type: 'ACCOUNT_NOT_SELECTED',
          title: 'Account was not selected',
          message:
            'You must selected account first in order to select targeting group.'
        }
      }));

      return;
    }

    this.setState(
      {
        ...this.state,
        searchingTargeting: name
      },
      () => {
        this.delayTargetingSearch(query, name);
      }
    );
  };

  delayTargetingSearch = (query, name) => {
    const { form, token, targetingSearchTimeoutId } = this.state;
    const { accountId } = form;

    if (!query || query === '') return;

    if (!accountId) return;

    clearTimeout(targetingSearchTimeoutId);

    const tmpTimeoutId = setTimeout(() => {
      getDetailedTargeting(query, accountId, token).then((result) => {
        const options = result.data
          ? result.data.map((item) => {
              const { id, name: targetingName } = item || {};

              return {
                key: id,
                value: id,
                text: targetingName
              };
            })
          : [];

        this.setState((prevState) => ({
          ...prevState,
          searchingTargeting: '',
          includeTargetingOptions:
            name === DETAILED_INCLUDE
              ? options
              : prevState.includeTargetingOptions,
          excludeTargetingOptions:
            name === DETAILED_EXCLUDE
              ? options
              : prevState.excludeTargetingOptions
        }));
      });
    }, 1000);

    this.setState((prevState) => ({
      ...prevState,
      targetingSearchTimeoutId: tmpTimeoutId
    }));
  };

  onErrorModalClose = () => {
    this.setState((prevState) => ({
      ...prevState,
      error: {
        type: null,
        title: '',
        message: ''
      }
    }));
  };

  selectDate = (date, day) => {
    const form = this.state.form;
    form[date] = day;
    this.setState({ form });
  };

  handleFormInputChange = (event, { name, value }) => {
    this.setState({ form: { ...this.state.form, [name]: value } });
  };

  onAdCheck = (event, { adId, checked }) => {
    if (checked) {
      this.setState((prevState) => ({
        ...prevState,
        checkedAdIds: [...prevState.checkedAdIds, adId]
      }));
    } else {
      const { checkedAdIds } = this.state;

      const newList = checkedAdIds.filter((id) => id !== adId);
      this.setState((prevState) => ({
        ...prevState,
        checkedAdIds: newList
      }));
    }
  };

  // Method to pre select form with test data
  onFillTestButtonClick = () => {
    const { packageToLaunch, pages } = this.props;
    const { token, formInState } = this.state;
    createTestForm(packageToLaunch, pages, token, formInState).then((form) => {
      if (!form) return;

      this.setState((prevState) => ({
        ...prevState,
        ...form
      }));
    });
  };

  // Count how many instances of the same ad belongs to the adset
  countDuplicateAds = (packageToLaunchAds) => {
    try {
      const adIds = [];
      const adIdCounterObjects = [];
      packageToLaunchAds.map((ad) => adIds.push(ad.ad.id));
      const adIdsFromSet = Array.from(new Set(adIds));
      adIdsFromSet.forEach((adIdFromSet) => {
        const { length } = adIds.filter((id) => adIdFromSet === id);
        const newAdIdCounter = { adId: adIdFromSet, count: length };
        adIdCounterObjects.push(newAdIdCounter);
      });
      this.setState({ duplicateAdCounters: adIdCounterObjects });
    } catch (error) {
      toast.warn(
        `An error occured with getting packages and/or ads to launch!`,
        {
          position: 'bottom-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        }
      );
      console.log('Something went wrong in countDuplicateAds(): ', error);
    }
  };

  duplicateAdFormData = (id, adId, adType) => {
    try {
      const { form, token } = this.state;
      const { packageToLaunch } = this.props;
      const newForm = Object.assign({}, form);
      const adFormDataToCopy = newForm.ads.find((item) => item.id === id);

      if (adFormDataToCopy) {
        const { ads } = newForm;
        const formAds = [...ads];

        const matchingAds = packageToLaunch.ads.filter(
          (ad) => ad.ad.id === adId
        );

        const newFormAds = matchingAds.map((matchingAd) => {
          const newFormAd = Object.assign({}, adFormDataToCopy);
          if (adType === COLLECTION) {
            const productCatalogId = newFormAd.productCatalog;
            getProductSetOptions(
              productCatalogId,
              token
            ).then((productSetOptions) =>
              this.setState({ productSets: productSetOptions })
            );
          }
          newFormAd.id = matchingAd.id;
          newFormAd.adSetId = matchingAd.adSetId;

          return newFormAd;
        });

        for (let i = 0; i < formAds.length; i += 1) {
          if (formAds[i].adId === adId) {
            formAds.splice(i, 1);
          }
        }
        const newAdsToSave = formAds.concat(newFormAds);

        newForm.ads = newAdsToSave;

        toast.info(
          `The ${adType} Ad's fields have been duplicated ${matchingAds.length -
            1} time(s)`,
          {
            position: 'bottom-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          }
        );

        this.setState({
          form: newForm
        });
      } else {
        toast.warn(`The fields are empty!`, {
          position: 'bottom-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        });
      }
    } catch (error) {
      toast.error(`Something went wrong while copying the ad!`, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
      console.log('Error from duplicateAdFormData(): ', error);
    }
  };

  // Method to reset form fields
  resetFormFieldsInUi = (inputNames) => {
    inputNames.forEach((inputName) => {
      const { length } = document.getElementsByName(inputName);
      for (let i = 0; i < length; i += 1) {
        document.getElementsByName(inputName)[i].value = '';
      }
    });
  };

  // Method to reset ad fields in form
  resetAdFormData = () => {
    const { form } = this.state;
    const newForm = Object.assign({}, form);
    newForm.ads = [];
    this.resetFormFieldsInUi([
      'destinationUrl',
      'footerUrl',
      'productCatalog',
      'productSet'
    ]);
    toast(`Ad Fields have been cleared!`, {
      position: 'bottom-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
    this.setState({ form: newForm });
  };

  renderDetailedTargetingName = (adset, isHecCampaign) => {
    let detailedTargetingNameContent = (
      <b>{`${
        adset ? adset.adSetName : 'Unknown adset'
      } - Detailed Targeting`}</b>
    );

    if (isHecCampaign) {
      detailedTargetingNameContent = (
        <Popup
          position="right center"
          content="Certain detailed targeting may not be available when launching HEC campaigns"
          trigger={
            <b style={{ color: '#fbbd08' }}>
              <Icon name="warning sign" color="yellow" />
              {`${
                adset ? adset.adSetName : 'Unknown adset'
              } - Detailed Targeting`}
            </b>
          }
        />
      );
    }

    return detailedTargetingNameContent;
  };

  setBuildingAudiences = (value, audiencesObj) => {
    const { retargetingAudiences, lookalikeAudiences } = audiencesObj || {};
    this.setState(
      {
        ...this.state,
        buildingAudiences: value,
        retargetingAudiences: retargetingAudiences || null,
        lookalikeAudiences: lookalikeAudiences || null
      },
      () => {
        const {
          retargetingAudiences: retargetingAudienceState,
          lookalikeAudiences: lookalikeAudienceState
        } = this.state;
        if (retargetingAudienceState && lookalikeAudienceState) {
          this.launchPackage();
        }
      }
    );
  };

  alterIdsOfCollectionAdsToConvert = (adPrototypeId) => {
    const { idsOfCollectionAdsToConvert } = this.state;
    const newIds = idsOfCollectionAdsToConvert.includes(adPrototypeId)
      ? idsOfCollectionAdsToConvert.filter((id) => id !== adPrototypeId)
      : [...idsOfCollectionAdsToConvert, adPrototypeId];
    this.setState((prevState) => ({
      ...prevState,
      idsOfCollectionAdsToConvert: newIds
    }));
  };

  toggleConversionSelectModal = (toggleValue) => {
    this.setState((prevState) => ({
      ...prevState,
      isFailedCollectionAdModalOpen: toggleValue
    }));
  };

  render() {
    const { accounts, packageToLaunch, pages, productCatalogs } = this.props;
    const { package: packageObj } = packageToLaunch;
    const { name: packageName, product_description: defaultDesc } = packageObj;

    const {
      message,
      processing,
      productSets,
      adProductSets,
      audienceOptions,
      fillTestData,
      locationType,
      zipCodesToInclude,
      zipCodesToExclude,
      searchingTargeting,
      includeTargetingOptions,
      excludeTargetingOptions,
      error,
      launchingStatus,
      duplicateAdCounters,
      utmProfilesOptions,
      relaunchData,
      relaunchInProgess,
      token,
      packageContainsHecCampaign,
      adsNeedQcApproval,
      accountIdText,
      pageIdText,
      form,
      checkedAdIds,
      includeLookalikes,
      launchingPackage,
      buildingAudiences,
      collectionAdsToRelaunch,
      idsOfCollectionAdsToConvert,
      isFailedCollectionAdModalOpen,
      showInfoToast,
      infoToastText
    } = this.state;

    const {
      pixel,
      displayUrl,
      address,
      radius,
      accountId,
      pageId,
      startDate,
      endDate,
      description,
      utmOverrideSelected,
      packageWideProductCatalog
    } = form;

    const selectedPage =
      pageId && pageId !== ''
        ? pages.find((tmp) => tmp.value.pageId === pageId)
        : undefined;
    const selectedPageValue = selectedPage ? selectedPage.value : '';

    const descriptionOptions = [
      {
        key: 0,
        text: 'At dealership',
        value: 'At {{vehicle.dealer_name}}'
      },
      {
        key: 1,
        text: 'Vehicle price',
        value: '{{vehicle.price}}'
      },

      {
        key: 2,
        text: 'VIN number',
        value: '{{vehicle.vehicle_id}}'
      },
      {
        key: 3,
        text: 'Click to View Price',
        value: 'Click to View Price'
      }
    ];

    const defaultDescLabel = defaultDesc
      ? descriptionOptions.find((opt) => opt.value === defaultDesc).text
      : 'At dealership';

    if (showInfoToast && infoToastText.trim() !== '') {
      toast.info(infoToastText, {
        position: 'top-right',
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
      this.setState({ ...this.state, showInfoToast: false, infoToastText: '' });
    }

    const areCollectionAdsPresent =
      packageToLaunch.ads.filter(
        (ad) => ad.type === COLLECTION || ad.type.includes('DAA')
      ).length > 0;

    return (
      <div className="launch-package-div">
        <ToastContainer
          position="bottom-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <Grid stackable container padded centered>
          <Grid.Row>
            <Grid.Column>
              <Button onClick={this.goBackSearch} size="small" color="grey">
                Back
              </Button>

              <Button
                onClick={this.onFillTestButtonClick}
                size="small"
                color="blue"
              >
                Fill Test
              </Button>
            </Grid.Column>
          </Grid.Row>
          <Divider />
          <Grid.Row container={'true'}>
            <Grid.Column computer={4} tablet={8} mobile={16}>
              <span className="launch-package-name">{packageName}</span>
              <Divider hidden />
              <Dropdown
                className="field-accounts"
                placeholder="Ad Accounts"
                clearable
                search
                selection
                value={accountId}
                options={accounts}
                onChange={this.onAccountSelect}
              />
              <Divider hidden />
              <Form.Input
                className="field-account-id"
                placeholder="Account ID"
                value={accountIdText}
                onChange={this.handleAccountIdTextChange}
              />
              <Divider hidden />
              <Dropdown
                placeholder="Client Page Name"
                search
                selection
                options={pages}
                value={selectedPageValue}
                clearable
                onChange={this.onSelectPage}
              />
              <Divider hidden />
              <Divider hidden />
              <Form.Input
                className="field-page-id"
                placeholder="Page ID"
                value={pageIdText}
                onChange={this.handlePageIdChange}
              />
              <Divider hidden />
              <Form.Input
                placeholder="Pixel"
                type="text"
                name="pixel"
                readOnly
                value={pixel}
              />
              <Divider hidden />
              <div>
                <span>
                  <b>Start Date:</b>
                </span>
              </div>
              <DayPickerInput
                onDayChange={(day) => this.selectDate('startDate', day)}
                value={startDate}
              />
              <Divider hidden />
              <div>
                <span>
                  <b>End Date:</b>
                </span>
              </div>
              <DayPickerInput
                onDayChange={(day) => this.selectDate('endDate', day)}
                value={endDate}
              />
              <Divider hidden />
              <Form.Input
                placeholder="Display URL"
                type="text"
                name="displayUrl"
                value={displayUrl}
                onChange={this.handleFormInputChange}
              />
              <Divider hidden />
              <Form.Field className="launch-package-location-type">
                Address{' '}
                <Checkbox
                  disabled={packageContainsHecCampaign}
                  toggle
                  label="Zip Codes"
                  onChange={this.onLocationTypeChange}
                />
              </Form.Field>

              {locationType === ADDRESS ? (
                <div>
                  <Form.Input
                    placeholder="Address"
                    type="text"
                    name="address"
                    value={address}
                    onChange={this.handleFormInputChange}
                  />
                  <Divider hidden />
                  <Form.Input
                    placeholder="Mi. Radius"
                    type="text"
                    name="radius"
                    value={radius}
                    onChange={this.handleFormInputChange}
                  />
                </div>
              ) : (
                <div>
                  <Form.Field
                    type="include"
                    control={TextArea}
                    label="Include"
                    placeholder="Zip codes to include"
                    value={zipCodesToInclude}
                    onChange={this.onZipcodeChange}
                  />
                  <Divider hidden />
                  <Form.Field
                    type="exclude"
                    control={TextArea}
                    label="Exclude"
                    placeholder="Zip codes to exclude"
                    value={zipCodesToExclude}
                    onChange={this.onZipcodeChange}
                  />
                </div>
              )}

              <Divider hidden />
              <div>
                <span>
                  <b>Product Description:</b>
                </span>
              </div>
              <Dropdown
                placeholder={defaultDescLabel}
                defaultValue={defaultDesc || descriptionOptions[0].value}
                search
                name="description"
                selection
                options={descriptionOptions}
                value={description}
                disabled={
                  packageToLaunch.ads.filter((ad) => ad.type === COLLECTION)
                    .length < 1
                }
                onChange={this.handleFormInputChange}
              />
              <Divider hidden />
              <Dropdown
                placeholder="UTM Override"
                clearable
                search
                name="utmOverrideSelected"
                selection
                options={utmProfilesOptions}
                value={utmOverrideSelected}
                onChange={this.handleFormInputChange}
              />
              <Divider hidden />
              {areCollectionAdsPresent && (
                <div>
                  <Divider fitted />
                  <Divider hidden />
                  <div>
                    <span>
                      <b>Package-wide Product Catalog:</b>
                    </span>
                  </div>
                  <br />
                  <Popup
                    mouseEnterDelay={1000}
                    closeOnTriggerClick
                    closeOnDocumentClick
                    position="right center"
                    content={
                      <div>
                        <span>
                          Select a product catalog here to apply it to all
                          collection ads, where the product set will be cleared
                          for each.
                        </span>
                      </div>
                    }
                    trigger={
                      <Dropdown
                        className="large"
                        placeholder="Product Catalog"
                        search
                        selection
                        name="productCatalog"
                        options={productCatalogs}
                        value={packageWideProductCatalog}
                        onChange={this.onPackagewideProductCatalogSelection}
                      />
                    }
                  />
                </div>
              )}
            </Grid.Column>
            <Grid.Column computer={4} tablet={8} mobile={16}>
              {packageToLaunch
                ? packageToLaunch.campaigns.map((campaign) => {
                    const {
                      id: campaignId,
                      name: campaignName,
                      objective,
                      is_hec_campaign: isHecCampaign
                    } = campaign;
                    const { campaigns } = form || {};

                    const { spendCap, tags, productCatalog } =
                      campaigns.find((tmp) => tmp.id === campaignId) || {};

                    return (
                      <div key={`${campaignName}-div-${campaignId}`}>
                        <div>
                          <span className="input-title">
                            <b>{campaignName}</b>
                          </span>
                          <Form.Input
                            placeholder="Spend Cap"
                            type="text"
                            name="spendCap"
                            id={campaignId}
                            value={spendCap}
                            onChange={this.handleCampaignChange}
                          />
                          <Divider hidden />
                          <Form.Input
                            placeholder="Tags"
                            type="text"
                            name="tags"
                            id={campaignId}
                            value={tags}
                            onChange={this.handleCampaignChange}
                          />
                          {objective === PRODUCT_CATALOG_SALES ? (
                            <div>
                              <Divider hidden />
                              <Dropdown
                                placeholder="Product Catalog"
                                search
                                selection
                                name="productCatalog"
                                id={campaignId}
                                value={productCatalog}
                                options={productCatalogs}
                                onChange={this.onProductCatalogSelectionChange}
                              />
                            </div>
                          ) : null}
                        </div>
                        <Divider hidden />
                        <div>
                          {packageToLaunch.adsets
                            .filter((item) => item.campaignId === campaignId)
                            .map((adset) => {
                              const {
                                id: adsetId,
                                adSetName,
                                includeAudience,
                                includeTargeting
                              } = adset;
                              // selected targeting
                              const {
                                includeTargetingSelected,
                                excludeTargetingSelected
                              } = this.state;
                              const { adsets } = form || {};
                              let audiences;
                              let exclusions;
                              const foundAdset = adsets.find(
                                (tmp) => tmp.id === adsetId
                              );

                              if (
                                fillTestData &&
                                [
                                  CONVERSIONS,
                                  VIDEO_VIEWS,
                                  LINK_CLICKS
                                ].includes(objective)
                              ) {
                                audiences = adsets
                                  .find((tmp) => tmp.id === adsetId)
                                  .audiences.map((tmpAudience) =>
                                    tmpAudience ? tmpAudience.value : ''
                                  );
                                exclusions = adsets
                                  .find((tmp) => tmp.id === adsetId)
                                  .exclusions.map((tmpExclusion) =>
                                    tmpExclusion ? tmpExclusion.value : ''
                                  );
                              }

                              if (!fillTestData && foundAdset) {
                                const {
                                  audiences: formAudiences = []
                                } = foundAdset;
                                audiences =
                                  formAudiences.length > 0
                                    ? formAudiences.map((tmpAudience) =>
                                        tmpAudience ? tmpAudience.value : ''
                                      )
                                    : [];
                              }

                              const includedTargetings = includeTargetingSelected.find(
                                (selection) => selection.adSetId === adsetId
                              )
                                ? includeTargetingSelected
                                    .find(
                                      (selection) =>
                                        selection.adSetId === adsetId
                                    )
                                    .selected.map((selection) =>
                                      selection ? selection.name : ''
                                    )
                                : [];
                              const excludedTargetings = excludeTargetingSelected.find(
                                (selection) => selection.adSetId === adsetId
                              )
                                ? excludeTargetingSelected
                                    .find(
                                      (selection) =>
                                        selection.adSetId === adsetId
                                    )
                                    .selected.map((selection) =>
                                      selection ? selection.name : ''
                                    )
                                : [];
                              return (
                                <div key={`${adSetName}-div`}>
                                  <Divider hidden />
                                  <span className="input-title">
                                    <b>{adSetName}</b>
                                  </span>
                                  {objective === PRODUCT_CATALOG_SALES && (
                                    <div>
                                      <Dropdown
                                        placeholder="Product set"
                                        search
                                        selection
                                        name="productSet"
                                        campaignid={campaignId}
                                        id={adsetId}
                                        options={productSets}
                                        onChange={
                                          this.onProductSetSelectionChange
                                        }
                                      />
                                      <Divider hidden />
                                    </div>
                                  )}
                                  {foundAdset &&
                                    foundAdset.productSet &&
                                    objective === PRODUCT_CATALOG_SALES && (
                                      <div>
                                        <Dropdown
                                          selection
                                          placeholder="Optimization for Ad Delivery"
                                          name="optimizationGoal"
                                          campaignid={campaignId}
                                          id={adsetId}
                                          options={
                                            optimizationGoalsValues.PRODUCT_CATALOG_SALES
                                          }
                                          onChange={
                                            this.onProductSetSelectionChange
                                          }
                                        />
                                        <Divider hidden />
                                      </div>
                                    )}
                                  {[
                                    CONVERSIONS,
                                    VIDEO_VIEWS,
                                    LINK_CLICKS
                                  ].includes(objective) ||
                                  (objective === PRODUCT_CATALOG_SALES &&
                                    includeAudience) ? (
                                    <div>
                                      <Dropdown
                                        placeholder="Audiences"
                                        search
                                        multiple
                                        name="audiences"
                                        id={adsetId}
                                        campaignId={campaignId}
                                        className="launch-package-audiences"
                                        selection
                                        options={audienceOptions}
                                        value={audiences}
                                        onChange={this.onAudienceSelectAdset}
                                      />
                                      <Divider hidden />
                                      <Dropdown
                                        placeholder="Exclusions"
                                        search
                                        multiple
                                        className="launch-package-audiences"
                                        name="exclusions"
                                        id={adsetId}
                                        campaignId={campaignId}
                                        selection
                                        options={audienceOptions}
                                        value={exclusions}
                                        onChange={this.onAudienceSelectAdset}
                                      />
                                    </div>
                                  ) : null}

                                  {[
                                    CONVERSIONS,
                                    VIDEO_VIEWS,
                                    LINK_CLICKS
                                  ].includes(objective) ||
                                  (objective === PRODUCT_CATALOG_SALES &&
                                    includeTargeting) ? (
                                    <div>
                                      <Divider hidden />
                                      <span className="input-title">
                                        {this.renderDetailedTargetingName(
                                          adset,
                                          isHecCampaign
                                        )}
                                      </span>
                                      <div>
                                        <Dropdown
                                          placeholder="Targeting"
                                          search
                                          multiple
                                          name="detailedInclude"
                                          id={adsetId}
                                          campaignId={campaignId}
                                          className="launch-package-audiences detailed-targeting-dropdown"
                                          selection
                                          options={includeTargetingOptions}
                                          onSearchChange={
                                            this.onDetailedTargetSearch
                                          }
                                          onChange={this.onDetailedTargetSelect}
                                          loading={
                                            searchingTargeting ===
                                            DETAILED_INCLUDE
                                          }
                                        />
                                        <Segment>
                                          {includedTargetings.map((name) => {
                                            return <Label basic>{name}</Label>;
                                          })}
                                        </Segment>
                                        <Divider hidden />

                                        <Dropdown
                                          placeholder="Exclusions"
                                          search
                                          multiple
                                          className="launch-package-audiences detailed-targeting-dropdown"
                                          name="detailedExclude"
                                          id={adsetId}
                                          campaignId={campaignId}
                                          selection
                                          options={excludeTargetingOptions}
                                          onSearchChange={
                                            this.onDetailedTargetSearch
                                          }
                                          onChange={this.onDetailedTargetSelect}
                                          loading={
                                            searchingTargeting ===
                                            DETAILED_EXCLUDE
                                          }
                                        />

                                        <Segment>
                                          {excludedTargetings.map((name) => {
                                            return <Label basic>{name}</Label>;
                                          })}
                                        </Segment>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              );
                            })}
                        </div>
                        <Divider hidden />
                      </div>
                    );
                  })
                : null}
            </Grid.Column>
            <Grid.Column computer={8} tablet={16} mobile={16}>
              <PackageLaunchAdSectionComponent
                onRef={(ref) => this.packageLaunchAdSectionComponentRef(ref)}
                form={this.state.form}
                packageToLaunch={packageToLaunch}
                productSets={adProductSets}
                productCatalogs={productCatalogs}
                duplicateAdCounters={duplicateAdCounters}
                duplicateAdFormData={this.duplicateAdFormData}
                resetAdFormData={this.resetAdFormData}
                onAdCheck={this.onAdCheck}
                handleAdCardChange={this.handleAdCardChange}
                handleAdChange={this.handleAdChange}
                onProductCatalogSelectionChangeAd={
                  this.onProductCatalogSelectionChangeAd
                }
                onProductSetSelectionChangeAd={
                  this.onProductSetSelectionChangeAd
                }
                fbToken={token}
                handleAdsBatchChange={this.handleAdsBatchChange}
              />
              <Divider hidden />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider />
        <Segment>
          <Label ribbon color="blue" style={{ paddingTop: '0.25em' }}>
            <Checkbox
              checked={includeLookalikes}
              style={{ paddingTop: '0.25em' }}
              disabled={
                packageToLaunch.adsets.filter((adset) => adset.daaType)
                  .length === packageToLaunch.adsets.length
              }
              onChange={(event, { checked }) => {
                this.setState({ ...this.state, includeLookalikes: checked });
              }}
            />
            <span style={{ paddingLeft: '0.5em' }}>
              Create Retargeting and Lookalike audience adsets
            </span>
          </Label>
          <PackageLaunchLookalikeMaker
            token={token}
            accountId={accountId}
            pixel={pixel}
            launchingPackage={launchingPackage}
            pageObject={{ pageId, pageIdText }}
            includeLookalikes={includeLookalikes}
            setBuildingAudiences={this.setBuildingAudiences}
            packageToLaunch={packageToLaunch}
          />
        </Segment>
        <Divider />
        <Grid stackable>
          <Grid.Row>
            <Grid.Column width={relaunchData.length > 0 ? 11 : 15} />
            {relaunchData.length > 0 && (
              <Grid.Column width={1} style={{ paddingRight: 0 }}>
                {!relaunchInProgess && (
                  <Popup
                    position="left center"
                    content="Click here to select collection ads to relaunch as cinemagraphs"
                    trigger={
                      <Button
                        size="tiny"
                        icon="film"
                        floated="right"
                        color="facebook"
                        style={{
                          borderRadius: '15px',
                          opacity: relaunchInProgess ? 0 : 1
                        }}
                        onClick={() => this.toggleConversionSelectModal(true)}
                      />
                    }
                    on="hover"
                  />
                )}
              </Grid.Column>
            )}
            {relaunchData.length > 0 && (
              <Grid.Column width={2}>
                <Popup
                  position="top center"
                  content="Click here to relaunch failed ads"
                  trigger={
                    <Button
                      disabled={processing || relaunchInProgess}
                      className="launch-package-button"
                      onClick={this.handleRelaunchClick}
                      size="huge"
                      color="blue"
                    >
                      {relaunchInProgess || processing
                        ? 'Relaunching...'
                        : 'Relaunch'}
                    </Button>
                  }
                />
              </Grid.Column>
            )}
            {/* {relaunchData.length > 0 ? <Grid.Column width={1} /> : null} */}
            <Grid.Column width={relaunchData.length > 0 ? 2 : 1}>
              <Button
                disabled={
                  processing ||
                  relaunchInProgess ||
                  adsNeedQcApproval ||
                  buildingAudiences
                }
                className="launch-package-button"
                onClick={this.handleLaunchButtonClick}
                size="huge"
                color="green"
              >
                {processing && !relaunchInProgess ? 'Launching...' : 'Launch'}
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {message ? (
          <div className="launch-package-message">
            <span>{message}</span>
          </div>
        ) : null}

        <Message icon style={{ left: 0, bottom: 0 }} warning>
          {processing || relaunchInProgess ? (
            <Icon name="circle notched" loading />
          ) : (
            <Icon name="rocket" />
          )}
          <Message.Content>
            {processing || relaunchInProgess ? (
              <Message.Header>
                {relaunchInProgess ? 'Relaunching failed ads' : 'Launching'} in
                progress...
              </Message.Header>
            ) : (
              <Message.Header>
                {relaunchData.length > 0
                  ? 'Failed ads are ready to be relaunched.'
                  : 'Package is ready to be launched.'}
              </Message.Header>
            )}

            {processing || relaunchInProgess
              ? 'Please wait.'
              : `Click ${
                  relaunchData.length > 0 ? 'Relaunch' : 'Launch'
                } when ready.`}
          </Message.Content>
        </Message>

        {launchingStatus && (
          <Segment style={{ marginBottom: '5em' }}>
            <List>
              {launchingStatus.map((campaign) => {
                const {
                  name: campaignName,
                  status: campaignStatus,
                  adsets,
                  errorMessage: campaignErrorMessage
                } = campaign;

                return (
                  <List.Item>
                    <List.Header>{`Campaign - ${campaignName}`}</List.Header>
                    <List.Description>
                      {getLaunchingStatusMessage(campaignStatus)}
                      {getIconForLaunchingStatus(campaignStatus)}
                      <span style={{ fontWeight: 'bold' }}>
                        {campaignErrorMessage}
                      </span>
                    </List.Description>
                    <List.List>
                      {adsets.map((adset) => {
                        const {
                          name: adsetName,
                          status: adsetStatus,
                          ads,
                          errorMessage: adsetErrorMessage
                        } = adset;

                        // Possible TO DO: need to get adsets 1:1
                        const checkedAdsFromAdset = ads.filter((ad) =>
                          checkedAdIds.find((id) =>
                            // eslint-disable-next-line no-nested-ternary
                            adsetName.includes('_Lookalike')
                              ? ad.id === id * 2 + 1
                              : adsetName.includes('_Retargeting')
                              ? ad.id === id * 2
                              : ad.id === id
                          )
                        );

                        return (
                          <List.Item>
                            <List.Header> {`Adset - ${adsetName}`}</List.Header>
                            <List.Description>
                              {getLaunchingStatusMessage(adsetStatus)}
                              {getIconForLaunchingStatus(adsetStatus)}
                              <span style={{ fontWeight: 'bold' }}>
                                {adsetErrorMessage}
                              </span>
                            </List.Description>
                            <List.List>
                              {checkedAdsFromAdset.map((ad) => {
                                const {
                                  name: adName,
                                  status: adStatus,
                                  errorMessage: adErrorMessage
                                } = ad;

                                return (
                                  <List.Item key={`Ad - ${adName}`}>
                                    <List.Header>
                                      {' '}
                                      {`Ad - ${adName}`}
                                    </List.Header>
                                    <List.Description>
                                      {getLaunchingStatusMessage(adStatus)}
                                      {getIconForLaunchingStatus(adStatus)}
                                      <span style={{ fontWeight: 'bold' }}>
                                        {adErrorMessage}
                                      </span>
                                    </List.Description>
                                  </List.Item>
                                );
                              })}
                            </List.List>
                          </List.Item>
                        );
                      })}
                    </List.List>
                  </List.Item>
                );
              })}
            </List>
          </Segment>
        )}

        <CollectionToCinempraphSelectionModal
          openModal={isFailedCollectionAdModalOpen}
          toggleModal={this.toggleConversionSelectModal}
          collectionAdPrototypes={collectionAdsToRelaunch}
          idsOfCollectionAdsToConvert={idsOfCollectionAdsToConvert}
          alterIdsOfCollectionAdsToConvert={
            this.alterIdsOfCollectionAdsToConvert
          }
          fireRelaunch={this.handleRelaunchClick}
        />

        <Modal
          size="small"
          open={error && error.type}
          onClose={this.onErrorModalClose}
        >
          <Modal.Header>{error && error.title ? error.title : ''}</Modal.Header>

          <Modal.Content>
            {error && error.message ? error.message : ''}
          </Modal.Content>

          <Modal.Actions>
            <Button positive content="Close" onClick={this.onErrorModalClose} />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default PackageLaunch;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/PackageLaunch.js